import { Grid } from '@all-manager/design-system-v2';
import OpenPendingItemsSection from './OpenPendingItemsSection';
import OpenQuotesSection from './OpenQuotesSection';
import OpenTasksSection from './OpenTasksSection';
import RemindersSection from './RemindersSection';
import UpcomingEventsSection from './UpcomingEventsSection';

export default function OverviewTab() {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <OpenTasksSection />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <OpenPendingItemsSection />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <OpenQuotesSection />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <UpcomingEventsSection />
      </Grid>
      {/* Fifth card: spans the row rather than leaving a gap next to it. */}
      <Grid size={12}>
        <RemindersSection />
      </Grid>
    </Grid>
  );
}
